export const JUDGE_VIEW_ALL_COLUMNS = [
	{ heading: 'Name', value: 'judgeName' },
	{ heading: 'Email Address', value: 'email' },
	{ heading: 'Phone Number', value: 'phone' },
	{ heading: 'Status', value: 'displayStatus' }
];
